import generateRender from 'shared/utils/generateRender';
import DefaultBottomBar from './DefaultBottomBar';

export const BottomBarComponent = generateRender({
  default: DefaultBottomBar,
});

